import React from 'react';
import { makeStyles } from '@material-ui/core';
import { FieldProps, useField } from 'formik';
import DoneIcon from '@material-ui/icons/Done';

interface StyleType {
  isChecked: boolean;
  isError: boolean;
  isDisabled: boolean;
}

const useStyles = makeStyles((theme: any) => {
  return {
    label: {
      userSelect: 'none',
      cursor: 'pointer',
      fontSize: '0.75rem',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
      opacity: ({ isDisabled }: StyleType) => (isDisabled ? '0.5' : '1'),
      color: ({ isDisabled, isError }: StyleType) => {
        if (isDisabled) return 'inherit';
        if (isError) return 'red';

        return 'inherit';
      }
    },
    dumbCheckbox: {
      position: 'relative',
      width: '24px',
      height: '24px',
      minWidth: '24px',
      borderRadius: '2px',
      border: '1px solid',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: '0.2s',
      opacity: ({ isDisabled }: StyleType) => (isDisabled ? '0.5' : '1'),
      backgroundColor: ({ isChecked }: StyleType) => {
        return isChecked ? theme.palette.primary.main : '#E6E6E6';
      },
      borderColor: ({ isChecked, isError, isDisabled }: StyleType) => {
        if (isError && !isDisabled) return 'red';

        return isChecked ? 'transparent' : '#E6E6E6';
      },

      '&:hover': {
        backgroundColor: ({ isChecked }: StyleType) => {
          return isChecked ? '#004258' : '#A0A3BD';
        }
      }
    },
    text: {
      marginLeft: '0.8125rem',
      lineHeight: '1',
      whiteSpace: 'pre-line'
    },
    input: {
      position: 'absolute',
      visibility: 'hidden'
    },
    icon: { color: '#fff', fontSize: '1rem', fontWeight: 'bold' }
  };
});

interface Props extends FieldProps {
  label?: string;
  isDisabled?: boolean;
  onChange?: Function;
}

const CheckboxCustom = ({
  field,
  label,
  isDisabled = false,
  onChange
}: Props) => {
  const [
    ,
    { error, touched, value: currentValue, initialValue },
    { setValue }
  ] = useField(field.name);

  const isError = initialValue
    ? typeof error === 'string' && touched
    : typeof error === 'string';

  const classes = useStyles({ isChecked: !!currentValue, isError, isDisabled });
  return (
    <label className={classes.label}>
      <div className={classes.dumbCheckbox}>
        {currentValue && <DoneIcon className={classes.icon} />}
        <input
          className={classes.input}
          type="checkbox"
          onChange={() => {
            !isDisabled && setValue(!currentValue);
            !!onChange && onChange();
          }}
          checked={!!currentValue}
          disabled={isDisabled}
        />
      </div>
      {label && <span className={classes.text}>{label}</span>}
    </label>
  );
};

export default CheckboxCustom;
